import {
	Button,
	Flex,
	IconV2,
	LayoutBox,
	Nub,
	TextField,
} from '@bamboohr/fabric';
import React from 'react';
import LoginPassword from '../LoginInputs/PasswordInput/login-password';

export interface EmailPasswordFormProps {
	redirect?: string;
}

export const EmailPasswordForm: React.FC<EmailPasswordFormProps> = ({
	redirect,
}) => {
	const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

	return (
		<>
			<input type="hidden" name="tz" id="tz" value={timezone} />

			{redirect && redirect !== '' ? (
				<input type="hidden" name="r" value={redirect} />
			) : null}

			<div id="passwordFields">
				<Flex flexDirection="column" gap={2.5}>
					<TextField
						aria-label={$.__('Email')}
						data-placeholder-trigger="keydown"
						id="lemail"
						name="username"
						placeholder={$.__('Email Address')}
						width={9}
						InputProps={{
							startAdornment: (
								<Nub position="start">
									<IconV2 name="envelope-regular" size={16} />
								</Nub>
							),
						}}
					/>

					<LoginPassword />
				</Flex>

				<input name="login" type="hidden" value="Log in" />
				<input name="CSRFToken" type="hidden" value={window.CSRF_TOKEN} />

				<LayoutBox>
					<Button size="large" type="submit" width={100}>
						{$.__('Log In')}
					</Button>
				</LayoutBox>
			</div>
		</>
	);
};
